import * as React from 'react';
import { Lazyloader } from '../Lazyloader/Lazyloader';
import type { NewsArticlePage } from '../Types';

export interface ILandingPageNewsProps {
    items: NewsArticlePage[];
}

export class LandingPageNews extends React.Component<ILandingPageNewsProps> {
    constructor(props: ILandingPageNewsProps) {
        super(props);
    }

    public renderItem(item: NewsArticlePage, index: number): JSX.Element {
        return (
            <div className="news-module__news-box" key={index}>
                <a href={item.url} className="d-flex flex-wrap news-module__main-news">
                    <div className="fold__image">
                        <Lazyloader image={item.image} hasVideo={item.hasVideo} isBackgroundImage={false} />
                    </div>
                    <div className="news-module__text fold__content">
                        <strong>{item.title}</strong>
                        <div className="news-module__text-summary">
                            {item.newsCategory ? <span className="news-module__news-category">{item.newsCategory} · </span> : null}
                            {item.summary}
                        </div>
                    </div>
                </a>
            </div>
        );
    }

    public render(): JSX.Element {
        return <div className=" news-module">{this.props.items.map(this.renderItem)}</div>;
    }
}
